#
# Content editor including both HTML/Text areas and all the surrounding
# actions (like custom fields insertions, file imports, etc).
#
# @todo This has to be split into separate class methods instead of HUGE thing
#
class @ContentEditor

  @instances = {}

  @setup: (element) =>
    $container = $(element).closest(".editor-container")
    id = $container.attr("id")
    @instances[id] ||= new ContentEditor(id, $container)
    return @instances[id]

  constructor: (@id, @$container) ->
    @$form      = @$container.closest("form")

    # Prevent an unpleasant flashing that can occur while the editors load.
    @$container.css("max-height", "584px")
    delay(1000, => @$container.css("max-height", "none"))

    @wysiwyg_mode = $("[data-wysiwyg-mode]", @$container).attr("data-wysiwyg-mode")

    # wysiwyg_mode keeps its legacy "tinymce" value (see SystemConfig#wysiwyg_mode);
    # the editor it selects is HugeRTE.
    if @wysiwyg_mode == "tinymce" && hugerte?
      @$hugerte   = @$container.find("textarea.wysiwyg")
      @hugerte    = hugerte.get(@$hugerte.attr("id"))
      @hugerte    = null unless @hugerte instanceof hugerte.Editor
    else
      @$hugerte   = $()
      @hugerte    = null

    @$textarea  = @$container.find("textarea.standard_textarea")

    @format     = @$container.data("format")
    @cursors    = { textarea: { start: 0, end: 0 } }
    @contents   = { }

    ContentEditorVisibilityManager.setup()

    @edmInitializeFromForm()
    @bindEvents()
    @customizeLanguage()
    @showEditor()
    @editorTabChanged()

  @initializeHugerte:  (editor)   -> ContentEditor.setup($("##{editor.id}"))
  @initializeTextarea: (textarea) -> ContentEditor.setup(textarea)

  bindEvents: =>
    self = @
    # track where the cursor was before blurring so we can properly insert text
    @monitorCursors()
    # bind buttons that insert content
    @$container
      .on("click", "a.insert-unsubscribe-link", @insertUnsubscribeLink)
      .on("click", "a.insert-custom-field", -> self.insertCustomField(@))
      .on("click", "a.insert-confirmation-link", @insertConfirmationLink)
      .on("loadRawData", (e, data) => @replaceText(data))
      .on("click", ".open-images-browser", @openImagesBrowser)
      .on("click", ".insert-web-form-field", @insertWebFormField)
      .on("click", "a.generate-from-html-link", @convertHtmlToText)
    # bind tab switching buttons to distribute content among the tabs
    @$container.find(".editor-tab-control li.wysiwyg-tab-selector a, .editor-tab-control li.html-tab-selector a, .editor-tab-control li.edm-tab-selector a")
      .on("show", @editorTabChanging)
    @$container.find(".editor-tab-control li.wysiwyg-tab-selector a, .editor-tab-control li.html-tab-selector a, .editor-tab-control li.edm-tab-selector a")
      .on("shown", @editorTabChanged)
    # bind the submit event to distribute content among the tabs
    @$container.on("distribute", @distributeContentAmongTabs)
    @$form.on("submit", @formSubmitting)
    # mark the starting content
    @contents["wysiwyg"]  = @getWysiwygContent()
    @contents["textarea"] = @getTextareaContent()

  activeEditor:               => @$container.find(".tab-pane.active").data("editor")
  setTextareaContent: (t, fn) => @$textarea.val(t); fn?()
  getTextareaContent:         => @$textarea.val()

  setWysiwygContent: (t, fn) =>
    if @hugerte
      # Full-document (fullpage) editing is handled transparently by the
      # fullpageemulation HugeRTE plugin (see
      # js/legacy/concerns/hugerte_fullpageemulationplugin.js.coffee), which is
      # enabled for the presets that need it, so we just set/get raw content here.
      @hugerte.setContent(t)
      fn?()
    else
      fn?()

  getWysiwygContent: =>
    if @hugerte
      @hugerte.getContent()
    else
      ""

  getContent: (fn) =>
    switch @activeEditor()
      when "wysiwyg"  then fn(true, @getWysiwygContent())
      when "textarea" then fn(true, @getTextareaContent())
      when "edm"      then @edmGetHtml(fn)

  setContent: (t, fn) =>
    switch @activeEditor()
      when "wysiwyg"  then @setWysiwygContent(t, fn)
      when "textarea" then @setTextareaContent(t, fn)

  editorTabChanging: (event) =>
    $targetTab = $(event.target)

    if @activeEditor() == "edm"
      @edmPromptToSwitchTabs($targetTab, true)
    else if $targetTab.is(".edm-tab")
      @edmPromptToSwitchTabs($targetTab, false)
    else
      @distributeContentAmongTabs()

  editorTabChanged: =>
    switch @activeEditor()
      when "edm"
        @toggleLoadButtons(false)
        ContentEditor.edmSerializedActivate(@)
      else
        @toggleLoadButtons(true)

  formSubmitting: =>
    @distributeContentAmongTabs()
    $("input.active_html_editor", @$container).val(@activeEditor()) if @format == "html"
    return true

  distributeContentAmongTabs: =>
    switch @activeEditor()
      when "wysiwyg"
        currentContent = @getWysiwygContent()
        @setTextareaContent(currentContent) if @contents["wysiwyg"] != currentContent
      when "textarea"
        @distributeTextarea()
    return true

  distributeTextarea: =>
    value = @$textarea.val()
    @setWysiwygContent(value, => @contents["wysiwyg"] = @getWysiwygContent())

  monitorCursors: =>
    @$textarea.on "blur", =>
      @cursors["textarea"] = getInputSelection(@$textarea.get(0))

  showEditor: =>
    # Hide the placeholder and reveal the editor.
    @$container.find('.editor-placeholder').hide()
    @$container.find('.editor-real').show()

  # The "Load from File" and "Load from URL" buttons are unavailable in the
  # responsive editor; this greys them out and ignores clicks.
  toggleLoadButtons: (enabled) =>
    clickBlocker = (event) =>
      event.preventDefault()
      event.stopPropagation()
    _.each $(".load-from-source-button", @$container), (button) =>
      if enabled
        $(button)
          .removeClass("load-from-source-button-disabled")
          .off("click.click-blocker")
      else
        $(button)
          .addClass("load-from-source-button-disabled")
          .off("click.click-blocker")
          .on("click.click-blocker", clickBlocker)

  insertLink: (url, text) =>
    link =
      if @format == "html"
        "<a href=\"#{url}\">#{text}</a>"
      else
        url
    @insertTextAtCursor(link)
    return false

  insertUnsubscribeLink: => @insertLink("%%unsubscribe_link%%", t("phrases.unsubscribe_me"))

  insertConfirmationLink: (e) =>
    $a              = $(e.currentTarget)
    type            = $a.data("type")
    replacementCode = "%%#{ type }_confirmation_link%%"
    text            = t "phrases.confirm_my_#{ type }"
    @insertLink(replacementCode, text)

  insertCustomField: (customFieldAnchor) =>
    $customFieldAnchor = $(customFieldAnchor)
    $customFieldAnchor.closest(".modal").modal("hide")
    fieldName = $customFieldAnchor.attr("data-field-key").replace(/\s/g, "_")
    tag = "%%#{fieldName}%%"
    delay 250, => @insertTextAtCursor(tag)
    return false

  insertWebFormField: (event) =>
    $webFormLink = $(event.target)
    formName     = $webFormLink.data("form-name")
    formCode     = "%%#{ $webFormLink.data("replacement-code") }%%"
    @insertLink(formCode, formName)
    $webFormLink.closest(".modal").modal("hide")
    return false

  convertHtmlToText: (event) =>
    event.preventDefault()

    $link   = $(@)
    groupId = @$container.attr("data-group-id")
    $html   = $(".editor-container[data-group-id='#{ groupId }'][data-format='html']")

    return if $html.length != 1

    htmlEditor = ContentEditor.setup($html)

    fail = -> Dialogs.presentErrorModal(t("notices.html_to_text_conversion_failed"))

    htmlEditor.getContent (success, html) =>
      if success
        $.ajax
          method: "POST"
          url: Routes.convert_html_to_text_tools_path()
          data: { data: html }
          dataType: "html"
          success: (text) => @setContent(text)
          error: fail
      else
        fail()

  openImagesBrowser: (event) =>
    event.preventDefault()
    browserTarget = $(event.target).data("target")
    new ImagesBrowser browserTarget, (url) =>
      tag = "<img src='#{url}'>"
      @insertTextAtCursor(tag)

  replaceText: (text) =>
    Dialogs.hideAllModals()
    @$textarea.val(text)
    @distributeTextarea()
    return false

  insertTextAtCursor: (text) =>
    switch @activeEditor()
      when "wysiwyg"
        if @hugerte
          @hugerte.insertContent(text)
      when "textarea"
        currentValue  = @$textarea.val()
        currentValue  = currentValue.replace(/\r\n/g, "\n")
        start         = @cursors["textarea"]["start"]
        insertedValue = currentValue.slice(0, start) + text + currentValue.slice(start)
        @$textarea.val(insertedValue)
      when "edm"
        if @edmEditorState == @EDM_STATE_EDITING
          message = JSON.stringify({ action: "InsertToCursor", content: text })
          $("iframe.edm-frame", @$container).get(0).contentWindow.postMessage(message, "*")
        else
          Dialogs.presentErrorModal(t("responsive_content_editor.editor_not_ready"))
    return false

  customizeLanguage: =>
    if @hugerte
      menuItems = @hugerte.ui.registry.getAll().menuItems
      menuItems.image.text = "Insert/edit image"
      menuItems.link.text  = "Insert/edit link"

  @finalizeAllEditors: (fn) =>
    allEditors      = _.values(ContentEditor.instances)
    allHtmlEditors  = _.filter(allEditors, (editor) => editor.format == "html")
    edmEditors      = _.filter(allHtmlEditors, (editor) => editor.activeEditor() == "edm" && editor.$container.closest("[data-is-editor-section-visible=1]").length > 0 && editor.edmEditorState >= editor.EDM_STATE_EDITING)

    calculateEdmStepsRequired = ->
      _.inject(edmEditors, ((memo, editor) => memo + editor.edmStepsRequiredToSave()), 0)

    edmStepsTotal = calculateEdmStepsRequired()

    finalizeSubmission = ->
      # Instruct each editor to finalize itself for submission.
      _.each(allEditors, (editor) => editor.formSubmitting())
      fn?()

    # If we have *any* EDM editors, we need to process them one at a time and then proceed with submission.
    if edmStepsTotal > 0
      progressMessage = (message, progress) ->
        $message = $("<div></div>")
          .append($("<p></p>").text(message))
          .append($("<div class=\"progress\"><div class=\"bar\" style=\"width: #{ progress }%\"></div></div>"))

      processEdmEditor = (modal, index) ->
        if modal.isClosed()
          # The user cancelled the modal. We'll just halt here. We haven't
          # actually written anything to the form yet. Reset all of the
          # contents back to the "editing" state.

          for editor in edmEditors.slice(0, index)
            editor.edmReturnToEditing()
        else if index >= edmEditors.length
          # Done!
          modal.message(progressMessage(t("responsive_content_editor.saved", count: edmEditors.length), 100))
          delay 500, ->
            modal.hide()
            finalizeSubmission()
        else
          # Do it

          stepDoneFn = ->
            edmStepsComplete = edmStepsTotal - calculateEdmStepsRequired()
            percent = 100.0 * parseFloat(edmStepsComplete) / parseFloat(edmStepsTotal)
            modal.message(progressMessage(t("responsive_content_editor.saving", index: index + 1, count: edmEditors.length), percent))

          allDoneFn = (success, err) ->
            if success
              processEdmEditor(modal, index + 1)
            else
              modal.message(Dialogs.errorMessage(t("responsive_content_editor.save_failed")))
              modal.adjustPrimaryButton t("buttons.retry"), ->
                modal.adjustPrimaryButton(false)
                processEdmEditor(modal, index)

          edmEditors[index].edmFinalize(stepDoneFn, allDoneFn)

      Dialogs.presentUpdateableStatusModal progressMessage(t("responsive_content_editor.starting"), 0), {}, (modal) ->
        processEdmEditor(modal, 0)
    # Otherwise, we can immediately submit.
    else
      finalizeSubmission()

  # EDM Designer #

  EDM_STATE_INACTIVE:       0
  EDM_STATE_LOADING:        1
  EDM_STATE_EDITING:        2
  EDM_STATE_SAVED:          3
  EDM_STATE_LOADED_PROJECT: 4
  EDM_STATE_LOADED_HTML:    5
  EDM_STATE_FINISHED:       6

  edmActivate: (fn) =>
    ContentEditor.edmInstallReadyListener()

    if @edmEditorState > @EDM_STATE_INACTIVE
      fn?(false, null)
      return

    # Let the user know we're loading.
    $(".edm-placeholder", @$container).html($('<div class="loading-responsive-editor"></div>').text(t("responsive_content_editor.loading")))

    fnWithErrorHandling = (success, err) =>
      if !success || err
        @edmDisplayError(t("responsive_content_editor.loading_error.message"), t("responsive_content_editor.loading_error.retry_link"), => @edmActivate(fn))
      fn?(success, err)

    if @edmId
      if @edmOldPrefix && @edmNewPrefix && @edmOldPrefix != @edmNewPrefix
        @edmLoadExistingContentWithOldPrefix(fnWithErrorHandling)
      else
        @edmLoadExistingContent(fnWithErrorHandling)
    else
      @edmCreateNewContent({}, fnWithErrorHandling)

  @edmSerializedActivate: (editor) =>

    @edmSerializedActivateQueue ||= []
    @edmSerializedActivateQueue.push(editor)

    activateOne = =>
      editor = @edmSerializedActivateQueue[0]
      editor?.edmActivate (success, err) =>
        # Attempt to load all editors, even if one fails.
        @edmSerializedActivateQueue.shift()
        activateOne()

    if @edmSerializedActivateQueue.length == 1
      activateOne()

  edmLoadExistingContentWithOldPrefix: (fn) =>
    # This content was duplicated; We need to (1) pull the current "internal
    # format" for the content, (2) search and replace the old prefix with the
    # new, (3) create the new content using that internal format.
    @edm.getProject @edmId, (project, err, notFound) =>
      if notFound || ( project && !err )
        if notFound
          @edmWarnLoadFailed()
        else
          @edmInternal = JSON.stringify(project.document)

        @edmInternal = @edmInternal.replace(new RegExp(RegExp.escape(@edmOldPrefix), "g"), @edmNewPrefix)
        @edmOldPrefix = ""
        @edmCreateNewContent(JSON.parse(@edmInternal), fn)
      else
        fn?(false, err)

  edmLoadExistingContent: (fn) =>
    newName = @edmGenerateNewName()

    @edm.duplicateProject @edmId, newName, (project, err, notFound) =>
      if notFound
        @edmWarnLoadFailed()
        @edmCreateNewContent(JSON.parse(@edmInternal), fn)
      else if project && !err
        @edmOpenProject(project._id, newName, fn)
      else
        fn?(false, err)

  edmCreateNewContent: (document, fn) =>
    newName = @edmGenerateNewName()

    @edm.createProject newName, document, (project, err) =>
      if project && !err
        @edmOpenProject(project._id, newName, fn)
      else
        fn?(false, err)

  edmOpenProject: (projectId, projectName, fn) =>
    @edmReadyFn = (success) =>
      if success
        @edmId            = projectId
        @edmName          = projectName
        @edmIsEditingCopy = true
        @edmEditorState   = @EDM_STATE_EDITING
      fn?(success, null)

    $placeholder = @$container.find(".edm-placeholder")

    $iframe = $("<iframe></iframe>")
      .attr("src", @edm.openProjectURL(projectId))
      .attr("allowfullscreen", "true")
      .attr("marginheight", "0")
      .attr("marginwidth", "0")
      .attr("frameborder", "0")
      .width($placeholder.width())
      .height($placeholder.height())
      .addClass("edm-frame")
      .addClass("hide")

    # Add the iframe (on first load, this will be hidden) into the DOM. EDM
    # will send a message to us when the editor is ready - see the listener
    # defined after this class (grep for ProjectLoadingSuccess).
    $placeholder.append($iframe)

  edmEditorReady: (success) =>
    $(".loading-responsive-editor", @$container).hide()
    $("iframe", @$container).show()

    @edmReadyFn?(success)
    @edmReadyFn = null

  edmPushDataToFields: =>
    @$container.find("input.edm-id").val(@edmId)
    @$container.find("input.edm-name").val(@edmName)
    @$container.find("input.edm-internal").val(@edmInternal)
    @$container.find("input.edm-old-prefix").val(@edmOldPrefix)

    @setTextareaContent(@edmHtml)

  edmRetrieveDetails: (fn) =>
    @edm.getGeneratedProject @edmId, (project, err) =>
      if project && !err
        @edmInternal = JSON.stringify(project.document)
        @edmHtml     = project.html
        fn?(true)
      else
        fn?(false, err)

  # Save the project to EDM designer.
  edmSave: (fn) =>
    # The editor isn't even loaded, no changes have been made.. there's nothing to save.
    if !@edmIsEditingCopy
      fn?(true)
      return

    $iframe = $("iframe.edm-frame", @$container)
    myWindow = window
    edmWindow = $iframe.get(0).contentWindow

    listener = (event) =>
      if event.data == "Save result: success"
        fn?(true)
        myWindow.removeEventListener("message", listener)
      else if event.data == "Save result: failed"
        fn?(false)
        myWindow.removeEventListener("message", listener)

    myWindow.addEventListener("message", listener)
    edmWindow.postMessage("saveProject", "*")

  edmFinalize: (stepDoneFn, allDoneFn) =>
    goto = (state) =>
      @edmEditorState = state
      stepDoneFn?()
      # The delay is simply to ensure we get a fresh stack.
      delay 5, => @edmFinalize(stepDoneFn, allDoneFn)

    fail = => allDoneFn?(false)

    switch @edmEditorState
      when @EDM_STATE_EDITING
        @edmSave (success) =>
          if success
            goto(@EDM_STATE_SAVED)
          else
            fail()
      when @EDM_STATE_SAVED
        @edm.getProject @edmId, (project, err) =>
          if project && !err
            @edmInternal = JSON.stringify(project.document)
            goto(@EDM_STATE_LOADED_PROJECT)
          else
            fail()
      when @EDM_STATE_LOADED_PROJECT
        @edm.getProjectHtml @edmId, (html, err) =>
          if html && !err
            @edmHtml = html
            goto(@EDM_STATE_LOADED_HTML)
          else
            fail()
      when @EDM_STATE_LOADED_HTML
        @edmPushDataToFields()
        goto(@EDM_STATE_FINISHED)
      when @EDM_STATE_FINISHED
        allDoneFn?(true)

  edmGetHtml: (fn) =>
    if !@edmId
      fn(true, "")
    else if !@edmIsEditingCopy
      fn(true, @getTextareaContent())
    else
      Dialogs.presentUpdateableStatusModal t("responsive_content_editor.processing"), {}, (modal) =>
        @edmSave (success) =>
          if modal.isClosed()
            # The user cancelled the "Processing..." modal. Don't do anything with the results.
          else if success
            @edmRetrieveDetails (success, err) =>
              if success
                # Give the user time to actually see the modal before it goes away...
                delay 500, =>
                  if modal.isClosed()
                    # The user cancelled the "Processing..." modal. Don't do anything with the results.
                  else
                    modal.hide()
                    fn(true, @edmHtml)
              else
                fn(false, null)
          else
            fn(false, null)

  edmPromptToSwitchTabs: ($targetTab, isLeaving) =>
    isEntering = !isLeaving

    if isEntering
      @distributeContentAmongTabs()
      @edmTabApproved = true if @getTextareaContent() == ""

    if @edmTabApproved
      @edmTabApproved = false
      true
    else
      opts =
        yesPhrase: t("phrases.okay")
        noPhrase:  t("buttons.cancel")

      warning = t("responsive_content_editor.changing_tabs.#{ if isLeaving then 'away' else 'into' }")

      Dialogs.presentYesNoModal warning, opts, =>
        resolve = (htmlForOtherEditors) =>
          @setTextareaContent(htmlForOtherEditors)
          @distributeTextarea()
          @edmInitializeBlank()
          @edmTabApproved = true
          $targetTab.click()

        if isLeaving
          @edmGetHtml (success, html) =>
            if success
              resolve(html)
            else
              Dialogs.presentYesNoModal Dialogs.errorMessage(t("responsive_content_editor.changing_tabs.away_failed_to_read")), {}, =>
                resolve("")
        else
          # We are entering the EDM editor and clear the "other" contents.
          resolve("")
      false

  edmGenerateNewName: =>
    @edmNewNameSequenceNumber ||= 0
    @edmNewNameSequenceNumber  += 1

    "#{ @edmNewName } seq=#{ @edmNewNameSequenceNumber }"

  edmInitializeBlank: =>
    @edmUnload()

    @edm              = new EDM()
    @edmId            = null
    @edmName          = null
    @edmNewName       = @$container.find(".html-edm").data("edm-new-name")
    @edmInternal      = null
    @edmOldPrefix     = null
    @edmNewPrefix     = null
    @edmIsEditingCopy = false
    @edmTabApproved   = false

    @$container.find("input.edm-id").val("")
    @$container.find("input.edm-name").val("")
    @$container.find("input.edm-internal").val("")
    @$container.find("input.edm-old-prefix").val("")

  edmInitializeFromForm: =>
    if @activeEditor() == "edm"
      @edmEditorState   = @EDM_STATE_INACTIVE

      @edm              = new EDM()
      @edmId            = @$container.find("input.edm-id").val()
      @edmName          = @$container.find("input.edm-name").val()
      @edmNewName       = @$container.find(".html-edm").data("edm-new-name")
      @edmInternal      = @$container.find("input.edm-internal").val()
      @edmOldPrefix     = @$container.find("input.edm-old-prefix").val()
      @edmNewPrefix     = $("#edm_new_prefix").val()
      @edmIsEditingCopy = false
      @edmTabApproved   = false
    else
      @edmInitializeBlank()

  edmUnload: =>

    @edmEditorState   = @EDM_STATE_INACTIVE
    $("iframe.edm-frame", @$container).remove()

  edmDisplayError: (err, retryText, retryFn) =>

    $placeholder = $(".edm-placeholder", @$container)

    $errorContainer = $("<div></div>")
    $errorContainer.addClass("inline-notice inline-error")
    $error = $("<h2></h2>").text(err)
    $retryLine = $("<p></p>")
    $retryButton = $("<a></a>")
    $retryButton.attr("href", "javascript:void(0)")
    $retryButton.text(retryText)
    $retryButton.on("click", => retryFn())
    $retryLine.append($retryButton)
    $errorContainer.append($error)
    $errorContainer.append($retryLine) if retryFn
    $placeholder.html("").append($errorContainer)

    @edmUnload()

  edmStepsRequiredToSave: =>
    if @edmEditorState == @EDM_STATE_INACTIVE
      0
    else
      @EDM_STATE_FINISHED - @edmEditorState

  edmReturnToEditing: =>
    if @edmEditorState > @EDM_STATE_EDITING
      @edmEditorState = @EDM_STATE_EDITING

  edmWarnLoadFailed: =>
    if !ContentEditor.edmWarnedAboutLoadFailure
      ContentEditor.edmWarnedAboutLoadFailure = true

  @edmInstallReadyListener: =>
    if !@edmInstallReadyListenerDone
      # Attach an event listener for doing the right thing when EDM's ready message
      # comes. The event itself doesn't tell us which editor it loaded for, but we
      # can use its "source" to find the iframe.

      findFrame = (event) ->
        _.find $("iframe"), (iframe) ->
          iframe.contentWindow == event.source || iframe.contentWindow == event.source.parent

      listener = (event) ->
        isSuccess = event.data == "ProjectLoadingSuccess"
        isFailure = event.data == "ProjectLoadingFailed"

        if isSuccess || isFailure
          if ( iframe = findFrame(event) )
            ContentEditor.setup(iframe).edmEditorReady(isSuccess)

      window.addEventListener("message", listener)

    @edmInstallReadyListenerDone = true
